import { NavLink } from "react-router-dom";  

const data = {
    title: '1. Voornemen',
    content: <>
        <p>In dit inleidende hoofdstuk is een toelichting op de aanleiding en doelstelling van de herziening van de module Energietransitie en dit MER gegeven. Paragraaf <NavLink to='/energietransitie/1/3'>1.3</NavLink> en <NavLink to='/energietransitie/1/4'>1.4</NavLink> schetsen de scope en aanpak van dit MER op hoofdlijnen. Paragraaf <NavLink to='/energietransitie/1/5'>1.5</NavLink> beschrijft de relatie tussen dit MER en de herziening van de module Energietransitie. Tot slot geeft paragraaf <NavLink to='/energietransitie/1/6'>1.6</NavLink> een beschrijving van de relatie tussen de in dit MER gebruikte beoordelingscriteria en de Monitor Leefomgeving van de provincie Zuid-Holland.</p>
    </>,
    prev: '/energietransitie/samenvatting',
    next: '/energietransitie/1/1',

}

export default data